<template>
    <a href="#" class="like" @click.prevent="ctaFavorite()" :class="{ active: isFavorite }">
        <span class="icon-like"></span>
        Enregistrer
    </a>
</template>

<script>
    import addToWishlist from '../../mixins/addToWishList';

    export default {
        mixins: [addToWishlist],
        props: {
            cruise: {
                type: Object,
                required: true,
            },
        },
        data: () => ({
            isFavorite: false,
        }),
        beforeMount() {
            this.isFavorite = this.cruise.isFavorite;
        },
    };
</script>






// WEBPACK FOOTER //
// assets/js/components/cruise-product/AddToWishlistCta.vue